import {activityPlaces} from '@mep/pae-commons';
import {Form, Select} from 'antd';
import * as ValidatorProvider from 'i18next';
import PropTypes from 'prop-types';
import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';

const {ACTIVITY_PLACE_LINK_TYPES_ENUM} = activityPlaces;

const ActivityPlaceLinkTypeSelect = ({...props}) => {
  const {t} = useTranslation('activityPlace');
  const countries = ACTIVITY_PLACE_LINK_TYPES_ENUM.map((e) => ({value: e, label: t(`linkType.${e}`)}));

  return (<Select
    showSearch
    filterOption={true}
    allowClear={true}
    {...props}
    placeholder={t('selectPlaceholder')}
    optionFilterProp={'label'}
    options={countries}>
  </Select>);

};

ActivityPlaceLinkTypeSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func
};

ActivityPlaceLinkTypeSelect.defaultProps = {};

export default memo(ActivityPlaceLinkTypeSelect);

export const renderActivityPlaceLinkTypeSelect = ({formItemProps, field}) => {
  const rules = field?.required && [{required: true, message: ValidatorProvider.t('validateMessages.required')}];

  return (
    <Form.Item {...formItemProps} required={field?.required} rules={rules}>
      <ActivityPlaceLinkTypeSelect {...field?.widgetProps} {...field}/>
    </Form.Item>
  );
};

renderActivityPlaceLinkTypeSelect.propTypes = {
  formItemProps: PropTypes.object,
  field: PropTypes.object,
  form: PropTypes.object,
};
